<template>
  <div>
    <div>
      <img src="../../assets/image/about_03.jpg" class="banner" alt="">
    </div>
    <div class="page-container about">
      <div class="about-con">
        <h2 class="h2 text-center">杏坛概况</h2>
        <el-row>
          <el-col :span="12">
            <h4 class="h4">我们是谁？</h4>
            <p>北京杏坛艺讯拍卖有限公司是一个互联网+艺术+拍卖的平台。杏坛艺拍网络平台，隶属于北京杏坛艺讯 拍卖有限公司。立足学术，面向市场，传承中国传统文化艺术；为艺术家和收藏者及艺 术品爱好者，打造一个线上和线下的互动平台。
            </p>
            <p>艺术源于生活，也应归于生活。杏坛艺拍网络平台是以艺术 + 互联网 + 服务为运营模式。</p>
            <h4>我们能做什么？</h4>
            <p>杏坛艺拍网络平台以完善的平台功能和拍卖品类，只为打造更优质的一站式服务。希望 更多的艺术家、机构、收藏者参与指导，也期望借着现代科技的网络平台，让艺术生活 进入千家万户，让艺术品实现人与人之间零距离交易。
            </p>
            <h4>我们的服务</h4>
            <p>艺术时讯报道、艺术家专访、学术文章发布、艺术品拍卖、艺术家个人空间、微信在线 商城、私人订制、在线艺术活动直播、杏坛讲坛、杏坛夺宝、大家拍、优秀商家入驻等。
            </p>
            <h4>拍品种类</h4>
            <p>书画、文房、清供、茶具、金石、拓片、文玩杂项等。</p>
            <h4><router-link :to="{path:'/about/zhengshu'}" target="_blank">拍卖经营批准证书</router-link></h4>
            <p>本司的拍卖证书公示。</p>
          </el-col>
          <el-col :span="12">
            <div class="about-img">
              <img src="../../assets/image/example.png" alt="">
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
.about {
  margin-top: 88px;
  color: #666666;
}

.about .row {
  display: table;
  position: relative;
}

.about h4 {
  margin-bottom: 15px;
}

.about p {
  margin-bottom: 15px;
  line-height: 2;
}

.about-con .h2 {
  color: #333333;
}

.about-con {
  padding: 30px;
  background-color: #ffffff;
  box-shadow: 0px 1px 7px 0px rgba(11, 3, 6, 0.3);
}

.about .row > div:nth-child(2) {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
}

.about-con .about-img img {
  width: 100%;
}
</style>